// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WZ8J","newExpiryDate":"styles_newExpiryDate__Orco2","footer":"styles_footer__3EOry"};